import React, { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Loader from 'eventtia-ui-components/lib/Loader';
import Typography from '@material-ui/core/Typography';
import CartierSimplebar from '../CartierSimplebar';

const useStyles = makeStyles({
  root: {
    overflowY: 'auto',
    overflowX: 'hidden',
    maxHeight: '100%',
    marginRight: 0,
  },
  loader: {
    height: 150,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const SimplebarInfiniteScroll = ({
  children, fetchNextPageIfExists, loading, error,
}) => {
  const classes = useStyles();
  const rootRef = useRef(null);

  const onScroll = useCallback(() => {
    const rootNode = rootRef.current.getScrollElement();

    if (loading) return;
    const rootHeight = rootNode.offsetHeight;
    const rootScrollHeight = rootNode.scrollHeight - 40;
    const rootBottom = rootHeight + rootNode.scrollTop;

    if (rootBottom >= rootScrollHeight) fetchNextPageIfExists();
  }, [loading, fetchNextPageIfExists]);

  useEffect(() => {
    const rootNode = rootRef.current.getScrollElement();
    if (rootNode) rootNode.addEventListener('scroll', onScroll);
    return () => {
      if (rootNode) rootNode.removeEventListener('scroll', onScroll);
    };
  }, [loading, fetchNextPageIfExists, onScroll]);

  return (
    <CartierSimplebar
      className={classes.root}
      forceVisible="y"
      autoHide={false}
      rootRef={rootRef}
    >
      {error ? <Typography color="error">{error}</Typography> : children}
      <Loader
        loading={loading}
        className={classes.loader}
      />
    </CartierSimplebar>
  );
};

SimplebarInfiniteScroll.propTypes = {
  children: PropTypes.node.isRequired,
  fetchNextPageIfExists: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

SimplebarInfiniteScroll.defaultProps = {
  loading: false,
  error: undefined,
};

export default SimplebarInfiniteScroll;
